<template>
  <div class="row">
      <div class="col-sm-12">
          <div class="ibox">
              <div class="ibox-title">
                  <el-form  id="elForm"  :inline="true" :model="formInline" ref="formInline" label-width="85px" label-position="right" class="demo-form-inline" size="medium">
                    <el-form-item label="市：" prop="cityID" v-show="show.selCity">
                      <el-select v-model="formInline.cityID" placeholder="请选择市" @change="selectChange(1,formInline.cityID)">
                        <el-option v-for="item in selectcity" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="区县：" prop="countryID" v-show="show.selCountry">
                      <el-select v-model="formInline.countryID" placeholder="请选择区" @change="selectChange(2,formInline.countryID)">
                        <el-option v-for="item in selectarea" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                      <el-form-item label="幼儿园：" prop="gardenId">
                          <el-select v-model="formInline.gardenId" placeholder="请选择幼儿园" filterable>
                              <el-option v-for="item in selectGarden" :key="item.orgKindID" :label="item.fullName" :value="item.orgKindID"></el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item label="姓名：" prop="childName">
                          <el-input v-model="formInline.childName" placeholder="请输入姓名" style="width:205px"></el-input>
                      </el-form-item>
                      <el-form-item label="体检日期：" prop="phyDate">
                          <el-date-picker v-model="phyDate" type="daterange"
                           align="right" @change="changePhy" placeholder="选择日期范围" :picker-options="pickerOptions" ></el-date-picker>
                      </el-form-item>
                      <el-form-item label="体检类型：" prop="mecType">
                        <el-select v-model="formInline.mecType" placeholder="请选择体检类型">
                          <el-option key="" label="全部" value=""></el-option>
                          <el-option key="2" label="入园体检" value="2"></el-option>
                          <el-option key="3" label="六一体检" value="3"></el-option>
                          <el-option key="1" label="自定义体检" value="1"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="推送：" prop="isPushed">
                        <el-select v-model="formInline.isPushed" placeholder="请选择推送">
                          <el-option key="" label="全部" value=""></el-option>
                          <el-option key="1" label="未推送" value="0"></el-option>
                          <el-option key="2" label="已推送" value="1"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="下发：" prop="isIssued">
                        <el-select v-model="formInline.isIssued" placeholder="请选择下发">
                          <el-option key="" label="全部" value=""></el-option>
                          <el-option key="1" label="已下发" value="1"></el-option>
                          <el-option key="2" label="未下发" value="0"></el-option>
                          <el-option key="3" label="未匹配（未找到幼儿园）" value="2"></el-option>
                           <el-option key="4" label="未匹配（存在多家幼儿园）" value="3"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="性别：" prop="sex">
                        <el-select v-model="formInline.sex" placeholder="请选择性别">
                          <el-option key="" label="全部" value=""></el-option>
                          <el-option key="1" label="男" value="男"></el-option>
                          <el-option key="2" label="女" value="女"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                          <el-button class="btn-primary" @click="onSubmit(formInline)">查询</el-button>
                          <el-button class="btn-default" @click="onReset('formInline')">重置</el-button>
                      </el-form-item>
                  </el-form>
                  <div class="mb15">
                    <!-- <el-button @click="AddTo()"><i class="el-icon-edit"></i>&nbsp;添加</el-button>
                    <el-button @click="removeg()"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
                    <el-button @click="imports()"><i class="el-icon-upload"></i>&nbsp;导入</el-button>
                    <el-button @click="Issued()"><i class="el-icon-sold-out"></i>&nbsp;下发</el-button>
                    <el-button @click="isPushed()"><i class="el-icon-news"></i>&nbsp;推送</el-button> -->
                    <el-button v-for='(item,index) in generalArea' :key='index' class="btn-outline" @click="doClick(item.operFunc)"  plain>{{item.operName}}</el-button>
                  </div>
                  <el-table ref="multipleTable" id="tableList" class="table-bordered" :data="tableData" @select="tableSelect" @select-all="tableSelectAll" v-loading="tableLoading" element-loading-text="拼命加载中" bordertooltip-effect="dark" style="width: 100%">
                      <el-table-column type="selection" width="55"></el-table-column>
                      <el-table-column prop="childName" label="姓名"></el-table-column>
                      <el-table-column prop="sex" label="性别"></el-table-column>
                      <el-table-column prop="birthday" label="生日" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="age" label="年龄(岁.月)" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="gardenName" label="幼儿园" show-overflow-tooltip> </el-table-column>
                      <el-table-column prop="mecTypeName" label="体检类型" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="checkDate" label="体检日期" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="heightValueStr" label="身高(cm)" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="heightComment" label="身高评价" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="weightValueStr" label="体重(kg)" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="weightComment" label="体重评价" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="overallComment" label="综合评价" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="pushStatus" label="推送" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="sendStatus" label="下发" ></el-table-column>
                      <el-table-column prop="hospital" label="来源" show-overflow-tooltip></el-table-column>
                      <el-table-column label="操作" width='170'>
                        <template slot-scope="scope">
                            <!-- <el-button class="btn-primary btn-outline" @click="edit(scope.$index,scope.row)" plain size="small">修改</el-button>
                            <el-button class="btn-warning btn-outline" @click="childPhyDetail(scope.$index,scope.row)" plain size="small">详情</el-button>
                            <el-button class="btn-primary btn-outline" @click="printShow(scope.$index,scope.row)" plain size="small" style="margin:10px 0 0 0">报告</el-button> -->
                            <el-button v-for='(item,index) in listArea' :key='index' class="btn-outline el-button-left" @click="doClick(item.operFunc,scope.$index,scope.row)" size="small" plain>{{item.operName}}</el-button>
                            <el-button class="btn-outline el-button-left" v-if="scope.row.isIssued==3" @click="IssuedFunSingle(scope.$index,scope.row)" plain size="small">下发</el-button>
                        </template>
                      </el-table-column>
                  </el-table>
                  <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="formInline.pageNum"
                  :page-sizes="[10, 25, 50, 100]"
                  :page-size="formInline.pageSize"
                  layout="total,sizes,prev,pager,next,jumper"
                  :total="total" style="margin-top: 10px;">
                  </el-pagination>
              </div>
          </div>
      </div>
      <!--彈出的添加-->
    <el-dialog id="elDialog" :title="dialogTitle" :show-close="showClose" :visible.sync="dialogTableVisible" :width="width" min-width="500px" :before-close="handleClose" :close-on-click-modal='false'>
      <router-view v-on:close="close" v-on:openMsgBox="openMsgBox" v-if='dialogTableVisible'></router-view>
    </el-dialog>
</div>
</template>
<script>
import { MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import common from '../../com/common'
export default {
  name: '',
  data () {
    var that = this
    return {
      dialogTableVisible: false,
      dialogTitle:"",
      // popupMsg:false,
      tableData: [], // 数据表数据
      tableSelection: [], // 数据表选择数据集合
      tableSelectObj: {}, // 数据表单条选择数据对象
      tableSelectKey: '',
      tableLoading: false,
      phyDate: '',
      width: '70%',
      showClose: true,
      formInline: {// 筛选条件表单数据
        cityID: '',
        countryID: '',
        provinceID: '',
        gardenId: '',
        childName: '',
        sex: '',
        mecType: '',
        isPushed: '',
        isIssued: '',
        pageNum: 1,
        pageSize: 10
      },
      show: {
        selCountry: false,
        selCity: false
      },
      selectpro: [], // 筛选条件下拉框省数据
      selectcity: [], // 筛选条件下拉框市数据
      selectarea: [], // 筛选条件下拉框区数据
      selectGarden: [{orgKindID: '', fullName: '全部'}], // 筛选条件下拉框幼儿园数据
      currentPage: 1,
      total: 0,
      pickerOptions: {
        shortcuts: [ {
          text: '过去七天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '过去30天',
          onClick (picker) {
            const end = new Date()
            const start = that.GetMonthStr(1)
          //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '过去半年',
          onClick (picker) {
            const end = new Date()
            const start = that.GetMonthStr(6)
          //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '过去一年',
          onClick (picker) {
            const end = new Date()
            const start = that.GetMonthStr(12)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      generalArea:[],
      listArea:[]
    }
  },
  watch:{
    dialogTableVisible(val, oldVal) {
      if(val == false) {
        this.dialogTitle = "";
      }
    }
  },
  methods: {
    handleSizeChange (val) { // 分页每页条数改变事件
      this.formInline.pageSize = val
      this.getOrgList(this.formInline)
    },
    handleCurrentChange (val) { // 分页页数改变事件
      this.formInline.pageNum = val
      this.getOrgList(this.formInline)
    },
    GetMonthStr (AddMonthCount) { // 获取过去几个月
      var dd = new Date()
      dd.setMonth(dd.getMonth() - AddMonthCount)// 获取AddMonthCount月后的日期
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1// 获取当前月份的日期
      var d = dd.getDate()
            // 判断 月
      if (m < 10) {
        m = '0' + m
      } else {
        m = m
      }
            // 判断 日n
      if (d < 10) { // 如果天数<10
        d = '0' + d
      } else {
        d = d
      }
      return y + '-' + m + '-' + d
    },
    handleClose () {
      let that = this
      this.width = '70%'
      this.showClose = true;
      that.dialogTableVisible = false
      that.dialogTable = false
    },
    close (flag, refresh) {
      let that = this
      this.width = '70%'
      this.showClose = true;
      that.dialogTableVisible = flag
      if (refresh === true) {
        that.getOrgList(that.formInline)
      }
    },
    getDateN (date) {
      date = (date < 10) ? (date = '0' + date) : date
      return date
    },
    tableSelect (selection, val) { // 表格选中事件
      this.tableSelection = selection
      this.tableSelectObj = val
    },
    tableSelectAll (selection) {
      this.tableSelection = selection
    },
    onSubmit (pram) { // 查询条件查询按钮点击事件
      pram.pageNum = 1
      this.getOrgList(pram)
    },
    getOrgList (pram) { // 获取表格数据
      var that = this
      api.post(config.host + 'childMec/getChildMECInfoList.do', pram).then(function (response) {
        that.tableData = response.body.list
        that.total = response.body.page.total
        that.tableSelection = [] // 数据表选择数据集合
        that.tableSelectObj = {} // 数据表单条选择数据对象
      })
    },
    onReset (formName) { // 查询条件重置
      this.$refs[formName].resetFields()
      this.phyDate = ''
      this.formInline.startDate = ''
      this.formInline.endDate = ''
    },
    changePhy (val) { // 体检日期的转换
      if (val) {
        var d = new Date(val[0])
        var b = new Date(val[1])
        var startYouWant = d.getFullYear() + '-' + this.getDateN(d.getMonth() + 1) + '-' + this.getDateN(d.getDate())
        var endYouWant = b.getFullYear() + '-' + this.getDateN(b.getMonth() + 1) + '-' + this.getDateN(b.getDate())
        this.formInline.startDate = startYouWant
        this.formInline.endDate = endYouWant
      } else {
        this.formInline.startDate = ''
        this.formInline.endDate = ''
      }
    },
    selectChange (type, parentID) { // 下拉框值改变事件  type=1市下拉框的值改变事件   type=2区下拉框的值改变事件
      if (type === 1) {
        this.selectarea = [{id: '', name: '全部'}]
        if (parentID !== '') {
          this.getList('common/getAreasList.do', { 'parentID': parentID }, 'selectarea')
        }
        this.formInline.countryID = ''
        this.selectGarden = [{orgKindID: '', fullName: '全部'}]
        this.formInline.gardenId = ''
        this.getList('orgkind/getOrgKindListByArea.do', {provinceID: this.formInline.provinceID, cityID: this.formInline.cityID, countryID: ''}, 'selectGarden', true)
      } else if (type === 2) {
        this.selectGarden = [{orgKindID: '', fullName: '全部'}]
        this.formInline.gardenId = ''
        this.getList('orgkind/getOrgKindListByArea.do', {provinceID: this.formInline.provinceID, cityID: this.formInline.cityID, countryID: parentID}, 'selectGarden', true)
      }
    },
    getList (url, param, key, isOrg) {
      var that = this
      that[key + ''] = []
      api.post(url, param).then(function (response) {
        that[key + ''] = response.body.list
        if (isOrg) {
          that[key + ''].splice(0, 0, {orgKindID: '', fullName: '全部'})
        } else {
          that[key + ''].splice(0, 0, {id: '', name: '全部'})
        }
      })
    },
    childPhyDetail (index, row) { // 详情
      this.width = '70%'
      this.dialogTableVisible = true
      this.$router.push({path: '/childPhy/detail/', query: { list: row }})
      this.dialogTable = true
    },
    printShow (index, row) { // 打印
      let that = this
      // 先查询本报告是否购买了
      var nparm = {
        // 1 业务类型为妇保院儿童体检报告 2 妇保院端幼儿园体检报告
        'bizType': 1,
        'bizId': row.id
      }
      api.post(config.khsHost + 'support/reChargeAndConsume/getConsumeAndReCharge.do', nparm).then(function (json) {
        // 已经购买过，直接展示
        if(json.success === true && json.body.consume != undefined) {

          that.width = '70%'
          that.dialogTableVisible = true
          if (row.provinceID === 370000 || row.provinceID === 430000) {
            that.$router.push({path: '/childPhy/printSd', query: {list: row}})
          } else {
            that.$router.push({path: '/childPhy/print', query: {list: row}})
          }
          that.dialogTable = true

        } else if(json.body.reCharge.surplus < 2) {
          that.$confirm('当前余额：'+json.body.reCharge.surplus+'元，余额不足，请前去充值', '提示', {
                  confirmButtonText: '去充值',
                  cancelButtonText: '取消',
                  type: 'warning'
          }).then(() => {
            window.open(config.khsHost + 'h5_orgPay/payReCharge.html?token='+localStorage.getItem('Haiziguo-Token'))
          }).catch(() => {
            that.$message({
              type: 'info',
              message: '已取消去充值'
            })
          });
        } else {

          that.$confirm('当前余额：'+json.body.reCharge.surplus+'元，本报告需要付费2元，确定购买吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            nparm = {
              // 1 业务类型为妇保院儿童体检报告 2 妇保院端幼儿园体检报告
              'bizType': 1,
              'bizId': row.id,
              // 每次消费 2元
              'consume': 2
            }
            api.post(config.khsHost + 'support/reChargeAndConsume/addConsume.do', nparm).then(function (json) {
              // 购买成功展示
              if(json.success === true && json.body == 1) {
                that.width = '70%'
                that.dialogTableVisible = true
                if (row.provinceID === 370000 || row.provinceID === 430000) {
                  that.$router.push({path: '/childPhy/printSd', query: {list: row}})
                } else {
                  that.$router.push({path: '/childPhy/print', query: {list: row}})
                }
                that.dialogTable = true

              } else {
                that.$confirm('余额不足，请前去充值', '提示', {
                  confirmButtonText: '去充值',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  window.open(config.khsHost + 'h5_orgPay/payReCharge.html?token='+localStorage.getItem('Haiziguo-Token'))
                }).catch(() => {
                  that.$message({
                    type: 'info',
                    message: '已取消去充值'
                  })
                });
              }
            }).catch((data) => {

            });
          }).catch(() => {
            that.$message({
              type: 'info',
              message: '已取消购买'
            })
          });
        }
      })
    },
    printShowSelected(){
      if (this.tableSelection.length === 0) {
        this.showMsgTip('请选择要打印的数据', 'false')
      }else{
        this.width = '70%'
        this.showClose = false;
        this.dialogTableVisible = true
        if (this.tableSelection[0].provinceID === 370000  || this.tableSelection[0].provinceID === 430000) {
          this.$router.push({path: '/childPhy/printSdBatch', query: {list: this.tableSelection}})
        } else {
          this.$router.push({path: '/childPhy/printBatch', query: {list: this.tableSelection}})
        }
        this.dialogTable = true
      }
    },
    showMsgTip (value, type) { // 提示消息
      if (type === 'false') {
        this.$message({
          message: value
        })
      } else {
        this.$message({
          message: value,
          type: type
        })
      }
    },
    removeg () { // 删除按钮
      if (this.tableSelection.length === 0) {
        this.showMsgTip('错误！您没有选择任何数据', 'false')
      } else {
        this.$confirm('您确定要删除所选择的体检记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.operation()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    operation () { // 删除
      var result = ''
      var that = this
      that.tableSelection.forEach(function (i) {
        if (result === '') {
          result = i.id
        } else {
          result = result + ',' + i.id
        }
      })
      var nparm = {
        'mecInfoIds': result
      }
      api.post(config.host + 'childMec/deleteChildMECInfo.do', nparm).then(function (response) {
        that.$message.success('操作成功')// 提示用户
        that.getOrgList(that.formInline)
      })
    },
    imports () { // 导入
      this.width = '600px'
      this.dialogTableVisible = true
      this.$router.push({ path: '/childPhy/import' })
      this.dialogTable = true
    },
    Issued () { // 下发
      var self = this
      var noPass
      if (self.tableSelection.length === 0) {
        noPass = true
        self.showMsgTip('错误！您没有选择任何数据', 'false')
        return false
      }
      for (var i = 0; i < self.tableSelection.length; i++) {
        var delData = self.tableSelection[i].sendStatus
        if (delData === '已下发' /*&&delData !== '未匹配'*/) {
          noPass = true
          self.showMsgTip('所选儿童的体检信息已下发过', 'false')
          return false
        }
      }
      if (noPass !== true) {
        self.$confirm('您确定要把所选择的体检数据下发给幼儿园吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.IssuedFun()
        })
      }
    },
    IssuedFun () { // 批量下发
      var result = ''
      var self = this
      this.tableSelection.forEach(function (i) {
        if (result === '') {
          result = i.id
        } else {
          result = result + ',' + i.id
        }
      })
      var nparm = {
        'mecInfoIds': result
      }
      api.post(config.host + 'childMec/updateBatchInfoIsUseState.do', nparm).then(function (response) {
        // this.$message.success("操作成功");//提示用户
        if (response.success === true) {
          var data = [response.body.errStr]
          data.push.apply(data, response.body.errStrList)
          self.openMsgBox(data, true, true)
        }
      })
    },
    IssuedFunSingle (index, row) { // 单个下发
      this.width = '510px'
      this.dialogTableVisible = true
      this.$router.push({ path: '/childPhy/issued', query: {list: row} })
      this.dialogTable = true
      this.dialogTitle = "下发"
    },
    openMsgBox (data, msg, colse) { // 显示导入结果弹窗
      const h = this.$createElement
      const arr = []
      arr.push(h('p', { style: 'text-align: center;font-size: 18px;color: #303133;' }, "下发完成!"))
      arr.push(h('p', {style: 'text-align: center;'}, [
            h('span', null, '成功 '),
            h('span', { style: 'color: green' }, data[0].split(',')[0]),
            h('span', null, ' 条，失败 '),
            h('span', { style: 'color: red' }, data[0].split(',')[1]),
            h('span', null, ' 条')
          ]))
      if(data[0].split(',')[1] > 0) {
        arr.push(h('p', { style: 'margin-top: 10px;color: #303133;' }, "失败信息如下："))
      }
      for (var i = 1; i < data.length; i++) {
        if (msg === true && i > 0) {
          data[i] = i + '.' + data[i]
          arr.push(h('p', { style: 'margin-top: 10px' }, data[i]))
        } else {
          arr.push(h('p', null, data[i]))
        }
      }
      this.$msgbox({
        title: '提醒',
        message: h('p', null, arr),
        showConfirmButton: false,
        beforeClose: (action, instance, done) => {
          if (action === 'cancel') {
            done()
          }
        },
        callback: (action, instance) => {
          if (colse !== false) {
            this.close(false, true);
          }
        }
      }).catch(() => {
      })
    },
    isPushed () { // 推送按钮
      var self = this
      var noPass
      if (self.tableSelection.length === 0) {
        noPass = true
        self.showMsgTip('错误！您没有选择任何数据', 'false')
        return false
      }
      for (var i = 0; i < self.tableSelection.length; i++) {
        var delData = self.tableSelection[i].pushStatus
        if (delData !== '未推送') {
          noPass = true
          self.showMsgTip('所选儿童的体检信息已推送过！', 'false')
          return false
        }
      }
      if (noPass !== true) {
        self.$confirm('您确定要把所选择的体检报告通过“孩子国家长”APP推送给孩子的家长吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.push()
        })
      }
    },
    push () { // 推送
      var result = ''
      var self = this
      this.tableSelection.forEach(function (i) {
        if (result === '') {
          result = i.id
        } else {
          result = result + ',' + i.id
        }
      })
      var nparm = {
        'mecInfoIds': result
      }
      api.post(config.host + 'childMec/pushReportToApp.do', nparm).then(function (response) {
        // this.$message.success("操作成功");//提示用户
        if (response.success === true) {
          var msg = response.msg
          self.showMsgTip(msg, true)
          self.onSubmit(self.formInline)
        }
      })
    },
    AddTo () { // 添加
      this.width = '70%'
      this.dialogTableVisible = true
      this.$router.push({ path: '/childPhy/add' })
      this.dialogTable = true
    },
    edit (index, row) { // 修改
      this.width = '70%'
      this.dialogTableVisible = true
      this.$router.push({ path: '/childPhy/edit/' + row.id })
      this.dialogTable = true
    },
    doClick(operFunc,index,row){
      switch(operFunc){
       case 'doModify':this.edit(index,row);break
       case 'showDetail':this.childPhyDetail(index,row);break
       case 'showReporter':this.printShow(index,row);break
       case 'doDelelte':this.removeg();break
       case 'doAdd':this.AddTo();break
       case 'pushInfo':this.isPushed();break
       case 'doImport':this.imports();break
       case 'doIssue':this.Issued();break
	   case 'exportBatch':this.printShowSelected();break
      }
    }
  },
  created () {
    var that = this
    that.getOrgList(that.formInline)
    api.get(config.host + 'org/getOrgDetail.do').then(function (json) {
      if (json.success === true) {
        if (json.body.scopeType === 1) { // 当前账号是省级妇保院
          that.show.selCity = true
          that.show.selCountry = true
          that.selectcity = [{id: '', name: '全部'}]
          that.selectarea = [{id: '', name: '全部'}]
          that.getList('common/getAreasList.do', { 'parentID': json.body.provinceID }, 'selectcity')
          // that.getList('common/getAreasList.do', { 'parentID': json.body.cityID }, 'selectarea')
          that.getList('orgkind/getOrgKindListByArea.do', {provinceID: json.body.provinceID}, 'selectGarden', true)
        } else if (json.body.scopeType === 2) { // 当前账号是市级妇保院
          that.show.selCountry = true
          that.selectarea = [{id: '', name: '全部'}]
          that.getList('common/getAreasList.do', { 'parentID': json.body.cityID }, 'selectarea')
          that.getList('orgkind/getOrgKindListByArea.do', {provinceID: json.body.provinceID, cityID: json.body.cityID}, 'selectGarden', true)
        } else if (json.body.scopeType === 3) { // 当前账号是区级妇保院/街道级妇保
          that.getList('orgkind/getOrgKindListByArea.do', {provinceID: json.body.provinceID, cityID: json.body.cityID, countryID: json.body.countryID}, 'selectGarden', true)
        } else if (json.body.scopeType === 4) {
          that.getList('orgkind/getOrgKindListByArea.do', {}, 'selectGarden', true)
        }
      }
    })
  },
  mounted(){
    let btnList = window.paramFromParent
    btnList = common.getBtnList(btnList)
    //this.generalArea = btnList.generalArea
    let that = this
    that.generalArea = [];
    btnList.generalArea.forEach(function (btn) {
        if(btn.operName != "打印") {
          that.generalArea.push(btn);
        }
    })
    this.listArea = btnList.listArea
  }
}
</script>

<style scoped>
.ml15 {
  margin-left: 15px;
}
#tableList .el-table .cell, .el-table th>div{
  padding-left: 0;
  padding-right: 0;
}
.el-button-left {
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 5px;
    float: left;
}
</style>
<style>
#elDialog .el-dialog__title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
    font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/physical/childPhy.vue